<template>
  <div class="ab_gameformat">
    <div class="ab_title">
      <slot name="title">
        <CustomFormatOption
          v-if="item.custom_tree"
          :customTree="item.custom_tree"
          :keys="['players']"
        />
        <div v-else>
          {{ item.variant }}
          {{ $t(`gametypes.groups.${item.format.toLowerCase()}`) }}
        </div>
      </slot>
    </div>
    <div class="ab_sub">
      {{
        [
          $t('common.num_players', { num: item.players.length }),
          item.date ? formatISODate(item.date, dateConf) : null,
        ]
          .filter(i => i)
          .join(', ')
      }}
    </div>
  </div>
</template>

<script>
import CustomFormatOption from '@/components/GameFormat/CustomFormatOption'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'HaGameformat',
  components: {
    CustomFormatOption,
  },
  mixins: [format_mix, float_mix],
  props: {
    item: Object,
    dateConf: {
      default: () => ({
        hour: true,
        minute: true,
      }),
    },
  },
  data() {
    return {
      copied: false,
    }
  },
  methods: {
    copyToClipboard(e) {
      this.copied = true
      navigator.clipboard.writeText(this.idString)
      setTimeout(
        () => {
          this.tooltipValue = false
          setTimeout(() => {
            this.copied = false
          }, 300)
        },
        this.nadaPurchased ? 1500 : 1500,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_gameformat {
    margin: var(--ha-street-margin);
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  &_title {
    font-size: 1rem;
    font-weight: 700;
  }
  &_sub {
    color: var(--clr-grey-2);
    font-size: 0.8rem;
  }
}
</style>
